const initialState = [];
//
export default function cm0003(state = initialState, action) {
  switch (action.type) {
    case 'SET_CM0003':
      if (action.payload) {
        return action.payload;
      } else {
        return state;
      }
    case 'SET_CM0003_ERROR':
      return state;
    default:
      return state;
  }
}
